module.exports = __webpack_public_path__ + "img/bg-left.a4adc3e2.png";